<template>
    <div>
		<div class="page-btns-box">
		    <el-button  type="primary"  size="small" @click="manage">新增类别</el-button>
		</div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="sort" label="置顶序位"></el-table-column>
                <el-table-column prop="alias" label="别名" min-width="150"></el-table-column>
                <el-table-column prop="styleTagView" label="对应系统选项"></el-table-column>
                <el-table-column prop="modifyTime" label="更新时间"></el-table-column>
                <el-table-column fixed="right" label="操作" width="100">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                             @click="manage(scope.row)"
                            >编辑</el-button
                        >
						<el-button
						    type="text"
						    size="small"
						    @click="del(scope.row.id)"
						    >删除</el-button
						>
                    </template>
                </el-table-column>
            </el-table>
        </div>        
        <LabelManage ref="labelManage" @submitSuccess="manageSuccess"></LabelManage>
    </div>
</template>

<script>

import LabelManage from './components/LabelManage'

export default {
    components: {LabelManage},
    data(){
        return {
            
            dataList: null,            
            listLoading: false,
            cityList: [],
            areaCode: []
        }
    },
    created(){
       
    },
    mounted() {
        this.getDataList();
    },
    methods:{
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/home/manage/dataList",
                method: "POST",
                data: {},
            })
			.then((res) => {
				const { state, msg, result } = res.data;
				if ( state == 1 && result) {					
					this.dataList = result || [];
				} else {
					this.$message.error(msg || "请求失败");
				}
			})
			.catch(() => {
				this.$message.error("请求错误");
			})
			.finally(() => {
				this.listLoading = false;
			});
        },
        del(id){
            this.$confirm("删除后该类别将不会展示在乐迷端。是否确认删除该类别？", '删除', {
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(() => {
                this.listLoading = true;
                this.$request({
                    url: '/home/manage/delete',
                    method: 'POST',
                    params: {id:id}
                }).then(res => {
                    const { state, msg } = res.data;
                    if( state == 1 ){
                        this.getDataList();
                    }else{
                        this.$message.error(msg || '请求失败');
                    }
                }).catch(() => {
                    this.$message.error('请求错误');
                }).finally(() => {
                    this.listLoading = false;
                });
            })
        },
		// 管理
		manage(row) {
		    this.$refs.labelManage.show({...row});
		},
		manageSuccess() {
		    this.getDataList();
		}
        
    }
}
</script>

<style lang="scss" scoped>

</style>